import React from 'react';
import { Button, Tooltip } from 'antd';
import Icon from '@ant-design/icons';
import { VscClearAll } from 'react-icons/vsc';
import { useBotaoLimparSelecao, checkHasSelectedRows } from './useBotaoLimparSelecao';

const IconDeselect = (props: any) => <Icon {...props} component={VscClearAll} />;

export { checkHasSelectedRows };

interface IBotaoLimparSelecaoProps {
    hasSelectedRows?: boolean;
    selectedRowKeys?: any[] | null;
    onClick: () => void;
    title?: string;
    style?: React.CSSProperties;
    className?: string;
    size?: 'large' | 'middle' | 'small';
}

export const BotaoLimparSelecao: React.FC<IBotaoLimparSelecaoProps> = ({
    hasSelectedRows,
    selectedRowKeys,
    onClick,
    title = 'Limpar seleção',
    style,
    className,
    size,
}) => {
    const { isSelected } = useBotaoLimparSelecao({ hasSelectedRows, selectedRowKeys });

    return (
        <Tooltip title={title} color="blue">
            <Button
                type="primary"
                size={size}
                disabled={!isSelected}
                className={className}
                style={{
                    fontSize: 20,
                    paddingTop: 0,
                    paddingBottom: 5,
                    paddingLeft: 8,
                    paddingRight: 8,
                    marginRight: 5,
                    marginBottom: 5,
                    ...style,
                }}
                onClick={onClick}
            >
                <IconDeselect />
            </Button>
        </Tooltip>
    );
};

export default BotaoLimparSelecao;
